import React from 'react';
import styled from 'styled-components';
import { InnerLayout } from '../styles/Layouts';
import Title from '../Components/Title';
import ServiceCard from '../Components/ServiceCard';
import design from '../img/design.svg';
import intelligence from '../img/intelligence.svg';
import gamedev from '../img/game-dev.svg';

function ServicesSection() {
  return (
    <InnerLayout>
      <ServicesSectionStyled>
        <Title title={'Services'} span={'services'} />
        <div className="services">
          <ServiceCard
            image={design}
            title={'Web Design'}
            paragraph={
              'Gained a lot of experience by doing some freelancer jobs and always try to learn new ways to improve my skills'
            }
          />
          <div className="mid-card">
            <ServiceCard
              image={intelligence}
              title={'3D Animation'}
              paragraph={
                'Created a lot of 3D modelling and animation, working with AutoCAD, Cinema 4D and a little bit with Blender '
              }
            />
          </div>
          <ServiceCard
            image={gamedev}
            title={'Game Development'}
            paragraph={'Learned and created some games using Unity platform, just for fun and to gain more knowledge'}
          />
        </div>
      </ServicesSectionStyled>
    </InnerLayout>
  );
}

const ServicesSectionStyled = styled.section`
  .services {
    margin-top: 5rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.5rem;
    @media screen and (max-width: 1000px) {
      flex-direction: column;
    }
    @media screen and (max-width: 950px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width: 650px) {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

export default ServicesSection;
